// extracted by mini-css-extract-plugin
export default {"employersEditButton":"EmployersEditButton_employersEditButton__ngUfO","employersEditButton__icon":"EmployersEditButton_employersEditButton__icon__fAB5U"};